<template>
  <div>
    <div class="pt-3 pl-3 pr-3 container-title">
        <span class="title-label">ข้อมูลส่วนตัว</span>
        <div class="line-gray"/>
    </div>
    <OverlayLoading :loading="loading" />
    <div v-if="!loading" class="pa-4 pr-2 ml-4">
      <!-- <div class="container-card pa-5"> -->
        <v-row class="container-card d-flex align-center pa-5">
          <v-col cols="12" sm="12" md="12" lg="4" class="d-flex flex-column align-center justify-center">
            <v-avatar size="150" rounded>
              <v-img
                cover
                :lazy-src="require('@/assets/icons/no_user.png')"
                :src="failed_image? require('@/assets/icons/no_user.png') : imgUser"
                :alt="userEmployeeID"
                v-on:error="onImgError"
              >
              </v-img>
            </v-avatar>
            <span class="label-codeid mt-3">{{`${user.titleTh} ${user.firstNameTh}   ${user.lastNameTh}` || '-'}}</span>
            <!-- <span class="label-nameen">Ms. Chanakan Prashyakorn</span> -->
            <!-- <span class="label-codeid">62149</span> -->
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="8" :class="!$vuetify.breakpoint.mobile ? 'line-lightblue' : ''">
            <div>
              <span class="label-nameth">ประวัติส่วนตัว</span>
              <v-row class="ml-0 mr-0 mb-0 mt-2 container-space">
                <div class="container-nameuser mr-5">
                  <span class="label-nameen mr-3">คำนำหน้า :</span>
                  <span class="label-nameen">{{user.titleTh || '-'}}</span>
                </div>
                <div class="container-nameuser mr-5">
                  <span class="label-nameen mr-3">ชื่อ :</span>
                  <span class="label-nameen">{{user.firstNameTh || '-'}}</span>
                </div>
                <div class="container-nameuser mr-5">
                  <span class="label-nameen mr-3">สกุล :</span>
                  <span class="label-nameen">{{user.lastNameTh || '-'}}</span>
                </div>
                <div class="container-nameuser">
                  <span class="label-nameen mr-3">รหัสพนักงาน :</span>
                  <span class="label-nameen">{{user.employeeId || '-'}}</span>
                </div>
              </v-row>

              <v-row class="ml-0 mr-0 mb-0 mt-2">
                <div class="container-nameuser mr-5">
                  <span class="label-nameen mr-3">ตำแหน่ง :</span>
                  <span class="label-nameen">{{user.position || '-'}}</span>
                </div>
                <div class="container-nameuser">
                  <span class="label-nameen mr-3">บริษัท :</span>
                  <span class="label-nameen">{{user.companyName || '-'}}</span>
                </div>
              </v-row>
            </div>

            <div class="mt-3">
              <span class="label-nameth">ตำแหน่ง</span>
              <v-row
                v-for="(item, index) in user.department"
                :key="index"
                class="ml-0 mr-0 mb-0 mt-2"
              >
                <div v-if="item.orgChartType == 'สายงาน'" class="container-nameuser" :class="item.orgChartLevel ? 'mr-5':''">
                  <span class="label-nameen mr-3">ลำดับสายงานที่ :</span>
                  <span class="label-nameen">{{item.orgChartLevel || '-'}}</span>
                </div>
                <div v-if="item.orgChartType == 'สายงาน'" class="container-nameuser" :class="item.orgChartName ? 'mr-5':''">
                  <span class="label-nameen mr-3">ชื่อสายงาน :</span>
                  <span class="label-nameen">{{item.orgChartName || '-'}}</span>
                </div>
                <div v-if="item.orgChartType == 'ฝ่ายงาน'" class="container-nameuser" :class="item.orgChartName ? 'mr-5':''">
                  <span class="label-nameen mr-3">ฝ่ายงาน :</span>
                  <span class="label-nameen">{{item.orgChartName || '-'}}</span>
                </div>
                <div v-if="item.orgChartType == 'ส่วนงาน'" class="container-nameuser">
                  <span class="label-nameen mr-3">ส่วนงาน :</span>
                  <span class="label-nameen">{{item.orgChartName || '-'}}</span>
                </div>
              </v-row>
            </div>

            <div class="mt-3">
              <span class="label-nameth">ประวัติการทำงาน</span>
              <v-row class="ml-0 mr-0 mb-0 mt-2">
                <div class="container-nameuser mr-5">
                  <span class="label-nameen mr-3">วันที่เริ่มงาน :</span>
                  <span class="label-nameen">{{ startDate(user.startWorkDate) || '-'}}</span>
                </div>
                <div class="container-nameuser">
                  <span class="label-nameen mr-3">อายุการทำงาน :</span>
                  <span class="label-nameen">{{ user.workingExperience.year || 0 }} ปี {{ user.workingExperience.month || 0 }} เดือน {{ user.workingExperience.day || 0 }} วัน</span>
                </div>
              </v-row>
            </div>
            <!-- <v-card-subtitle class="pb-0">Number 10</v-card-subtitle>

            <v-card-text class="text--primary">
              <div>Whitehaven Beach</div>

              <div>Whitsunday Island, Whitsunday Islands</div>
            </v-card-text>

            <v-card-actions>
              <v-btn
                color="orange"
                text
              >
                Share
              </v-btn>

              <v-btn
                color="orange"
                text
              >
                Explore
              </v-btn>
            </v-card-actions> -->
          </v-col>
        </v-row>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import { getUserAuth, hostImageUrlv3 } from '@/API/API'
import OverlayLoading from './OverlayLoading.vue'
// import OverlayLoading from '../_loading/overlay.vue'
import { EventBus } from '@/EventBus'
import moment from 'moment'

export default {
  name: 'profile',
  props: {
    tax_no: String
  },
  components: {
    OverlayLoading
  },
  data () {
    return {
      tax: this.tax_no,
      user: {},
      userEmployeeID: '',
      imageUser: null,
      failed_image: false,
      loading: true,
      companyId: ''
    }
  },
  mounted () {
    EventBus.$on('detailCompany', this.getSelectDetail)
  },
  created () {
    if (this.$store.state.token) this.initUserData()
  },
  computed: {
    imgUser () {
      return this.failed_image ? require('@/assets/icons/no_user.png') : this.imageUser
    }
  },
  methods: {
    initUserData () {
      const self = this
      self.user = self.$store.state.user
      self.userEmployeeID = self.$store.state.user.employeeId
      self.imageUser = `${hostImageUrlv3}/${self.$store.state.user.userImg || '_'}/${self.$store.state.user.emailOneId}`
    },
    onImgError (event) {
      this.failed_image = true
    },
    goLogin () {
      this.loading = true
      setTimeout(() => {
        this.$store.commit('clearToken')
        this.loading = false
        this.$router.push('/login')
      }, 2000)
    },
    getSelectDetail (companyId) {
      this.companyId = companyId
      this.$store.state.user.companyId = companyId
      // console.log(this.$store.state)
      // console.log('select: ', companyId, 'store: ', this.$store.state.user.companyId)
      this.changeUserDataByCompany()
    },
    async changeUserDataByCompany () {
      const self = this
      const obj = {
        companyId: self.$store.state.user.companyId
      }
      this.loading = true
      try {
        const res = await getUserAuth(this.$store.state.token, obj)
        // console.log('user after select: ', res)
        if (res.success) {
          if (res.result.companyId) {
            self.$store.state.user = res.result
          } else {
            // console.log(self.$store.state.user)
            EventBus.$emit('oldSelectCompanyId', self.$store.state.user.companyId)
          }
          setTimeout(() => {
            this.initUserData()
          }, 200)
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    startDate (date) {
      return moment(date).format('DD/MM/YYYY')
    }
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Athiti:wght@400;600&family=Sarabun:wght@200;500&display=swap');

.container-card {
  width: 100%;
  height: 100%;
  display: flex;
  border-radius: 15px;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}

.container-title {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.title-label {
  font-family: 'Sarabun', sans-serif !important;
  font-size:1.25rem;
  font-weight: bold;
  color: #333;
}

.line-lightblue {
  // width: 1vw;
  height: 100%;
  border-left: 0.2vw solid #f2f4fa;
  // border-right-color: rgba(242, 244, 250, 1);
  // background-color: rgba(242, 244, 250, 1);
}

.line-gray {
  background-color: rgba(221, 222, 224, 1);
  height: 1px;
  width: 85%;
}

.img-border {
  width: 10vw;
  height: 10vw;
  max-width: 10vw !important;
  max-height: 10vw !important;
  border-radius: 50%;
  // object-fit: cover;
}

.label-nameth {
  font-family: 'Sarabun', sans-serif !important;
  font-size: 1rem !important;
  font-weight: bold;
  color: #333;
}

.label-nameen {
  font-family: 'Sarabun', sans-serif !important;
  font-size: 1rem !important;
  font-weight: normal;
  color: rgba(0, 0, 0, 0.6);
}

.label-codeid {
  font-family: 'Sarabun', sans-serif !important;
  font-size: 1rem !important;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.6);
}

.container-nameuser {
  // width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}

</style>
